/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteFleetsParams,
  Fleets,
  FleetsInsertPayload,
  FleetsUpdate,
  GetFleetsParams,
  PatchFleetsParams,
  PostFleetsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getFleetsResponse200 = {
  data: Fleets[]
  status: 200
}

export type getFleetsResponse206 = {
  data: Fleets[]
  status: 206
}

export type getFleetsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getFleetsResponseSuccess = (getFleetsResponse200 | getFleetsResponse206) & {
  headers: Headers;
};
export type getFleetsResponseError = (getFleetsResponseDefault) & {
  headers: Headers;
};

export type getFleetsResponse = (getFleetsResponseSuccess | getFleetsResponseError)

export const getGetFleetsUrl = (params?: GetFleetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/fleets?${stringifiedParams}` : `${backendBaseUrl}/fleets`
}

/**
 * @summary Read rows from `fleets`.
 */
export const getFleets = async (params?: GetFleetsParams, options?: RequestInit): Promise<getFleetsResponse> => {

  const res = await fetch(getGetFleetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getFleetsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getFleetsResponse
}


export type postFleetsResponse201 = {
  data: Fleets[]
  status: 201
}

export type postFleetsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postFleetsResponseSuccess = (postFleetsResponse201) & {
  headers: Headers;
};
export type postFleetsResponseError = (postFleetsResponseDefault) & {
  headers: Headers;
};

export type postFleetsResponse = (postFleetsResponseSuccess | postFleetsResponseError)

export const getPostFleetsUrl = (params?: PostFleetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/fleets?${stringifiedParams}` : `${backendBaseUrl}/fleets`
}

/**
 * @summary Insert one or more rows into `fleets`.
 */
export const postFleets = async (fleetsInsertPayload: FleetsInsertPayload,
    params?: PostFleetsParams, options?: RequestInit): Promise<postFleetsResponse> => {

  const res = await fetch(getPostFleetsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fleetsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postFleetsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postFleetsResponse
}


export type patchFleetsResponse200 = {
  data: Fleets[]
  status: 200
}

export type patchFleetsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchFleetsResponseSuccess = (patchFleetsResponse200) & {
  headers: Headers;
};
export type patchFleetsResponseError = (patchFleetsResponseDefault) & {
  headers: Headers;
};

export type patchFleetsResponse = (patchFleetsResponseSuccess | patchFleetsResponseError)

export const getPatchFleetsUrl = (params?: PatchFleetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/fleets?${stringifiedParams}` : `${backendBaseUrl}/fleets`
}

/**
 * @summary Update the rows of `fleets` matching the given filters.
 */
export const patchFleets = async (fleetsUpdate: FleetsUpdate,
    params?: PatchFleetsParams, options?: RequestInit): Promise<patchFleetsResponse> => {

  const res = await fetch(getPatchFleetsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fleetsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchFleetsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchFleetsResponse
}


export type deleteFleetsResponse200 = {
  data: Fleets[]
  status: 200
}

export type deleteFleetsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteFleetsResponseSuccess = (deleteFleetsResponse200) & {
  headers: Headers;
};
export type deleteFleetsResponseError = (deleteFleetsResponseDefault) & {
  headers: Headers;
};

export type deleteFleetsResponse = (deleteFleetsResponseSuccess | deleteFleetsResponseError)

export const getDeleteFleetsUrl = (params?: DeleteFleetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/fleets?${stringifiedParams}` : `${backendBaseUrl}/fleets`
}

/**
 * @summary Delete the rows of `fleets` matching the given filters.
 */
export const deleteFleets = async (params?: DeleteFleetsParams, options?: RequestInit): Promise<deleteFleetsResponse> => {

  const res = await fetch(getDeleteFleetsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteFleetsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteFleetsResponse
}


